import {
  MOON_100,
  MOON_600,
  TEAL_300,
} from '@wandb/weave/common/css/color.styles';
import styled from 'styled-components';

export const MarkdownContainer = styled.div`
  max-width: 1000px;

  /* Style for better markdown display */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 24px;
    margin-bottom: 16px;
    font-weight: 600;
  }

  h1 {
    font-size: 2em;
  }
  h2 {
    font-size: 1.5em;
  }
  h3 {
    font-size: 1.25em;
  }

  p {
    margin-bottom: 16px;
    line-height: 1.6;
  }

  ul {
    margin-bottom: 16px;
    padding-left: 24px;
    list-style-type: disc;
  }

  ol {
    margin-bottom: 16px;
    padding-left: 24px;
    list-style-type: decimal;
  }

  li {
    margin-bottom: 8px;
  }

  code {
    background-color: ${MOON_100};
    padding: 2px 4px;
    border-radius: 3px;
    font-family: 'Inconsolata', monospace;
    font-size: 0.9em;
  }

  pre {
    background-color: ${MOON_100};
    padding: 16px;
    border-radius: 4px;
    overflow-x: auto;
    margin-bottom: 16px;
  }

  /* Make images responsive */
  img {
    max-width: 100%;
    height: auto;
  }

  blockquote {
    border-left: 4px solid ${TEAL_300};
    padding-left: 16px;
    margin: 16px 0;
    color: ${MOON_600};
  }

  table {
    margin-bottom: 16px;
    width: 100%;
    display: block;
    overflow-x: auto;
  }
`;
